export default {
  root: ({ instance }) => {
    const site = useSiteStore();
    return {
      class: [
        'block relative overflow-hidden',
        // Base Label Appearance
        '[&>*:last-child]:text-dark-800/40 dark:[&>*:last-child]:text-light-50/40',
        '[&>*:last-child]:absolute',
        '[&>*:last-child]:top-1/2',
        '[&>*:last-child]:-translate-y-1/2',
        '[&>*:last-child]:left-3',
        '[&>*:last-child]:pointer-events-none',
        '[&>*:last-child]:transition-all',
        '[&>*:last-child]:duration-200',
        '[&>*:last-child]:ease',

        // Filled Input Label Appearance
        'focus:[&>*:last-child]:top-3',
        'autofill:[&>*:last-child]:!top-3',
        'autofill:focus:[&>*:last-child]:!top-3',
        'autofill:[&>*:last-child]:!text-xs',
        'autofill:[&>*:last-child]:!text-base-priority',
        {
          '[&>*:last-child]:text-xs [&>*:last-child]:top-3 [&>*:last-child]:text-dark-900 dark:[&>*:last-child]:!text-light-50':
            !!instance?.$params?.attrs?.touched,
        },

        instance?.$params?.attrs?.['input-type'] === 'tel' &&
          site.getRegion === 'ZA' &&
          '[&>*:last-child]:!left-16',
        !!instance?.$attrs?.['data-prefix'] && '[&>*:last-child]:!left-16',
        instance?.$params?.attrs?.['input-type'] === 'tel' &&
          site.getRegion !== 'ZA' &&
          '[&>*:last-child]:!left-20',
        instance.$params?.attrs.disabled &&
          '[&>*:last-child]:!text-dark-800/30 [&>*:last-child]:dark:!text-light-700/50',
      ],
    };
  },
};
